import { IconChevronDownOutline18 as ChevronDown } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

export function InstallSnippetHeader({
	isOpen,
	canToggle,
	onToggle,
}: {
	isOpen: boolean
	canToggle: boolean
	onToggle: () => void
}) {
	const text = (
		<span className="block min-w-0">
			<span className="block font-semibold text-primary">Install snippet</span>
			<span className="block text-sm text-secondary">
				Paste this snippet before the closing{" "}
				<code className="rounded bg-gray-150 px-1 py-0.5 text-xs dark:bg-gray-800">
					&lt;/body&gt;
				</code>{" "}
				tag of your website.
			</span>
		</span>
	)

	if (!canToggle) return text

	return (
		<button
			type="button"
			aria-expanded={isOpen}
			onClick={onToggle}
			className="group/snippet flex w-full items-start justify-between gap-2 rounded-md text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
		>
			{text}
			<ChevronDown
				aria-hidden
				className={cn(
					"mt-1 h-4 w-4 flex-none text-tertiary group-hover/snippet:text-secondary",
					isOpen && "rotate-180",
				)}
			/>
		</button>
	)
}
